<div class="full-script-container">
  <app-full-script-table></app-full-script-table>
</div>
